export const isMobile = window.matchMedia('(max-width: 1024px)').matches;
